import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useIsF1Provider = (): boolean => {
  const [isF1Provider, setIsF1Provider] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const f1ProviderPermission: Permission = {
    resource: 'f1provider',
    action: 'readbasic',
    scope: 'provider',
  };

  const isF1Permission = useHasPermission(user, f1ProviderPermission);

  React.useEffect(() => {
    setIsF1Provider(isF1Permission);
  }, [isF1Permission]);

  return isF1Provider;
};
